<template>
  <v-card v-if="filteredTemplates.length > 0"
          tile
          class="mb-4">
    <v-card-title class="pb-0">
      <v-icon color="primary"
              class="mr-2">
        fas fa-fw fa-mail-bulk
      </v-icon>
      My Recent Templates
    </v-card-title>
    <v-list dense>
      <template v-for="template in filteredTemplates">
        <v-list-item :key="template.id"
                     class="d-block d-sm-flex pl-1 pl-sm-2 ">
          <v-list-item-icon class="mr-2">
            <v-btn @click.prevent="selectTemplate(template)"
                   class="mr-2"
                   small>
              Select
            </v-btn>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-if="template.is_featured">
              Name: {{ template.name }} (FEATURED)
            </v-list-item-title>
            <v-list-item-title v-else>
              Name: {{ template.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Subject: <em>{{ template.subject }}</em>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="template.is_english === false">
              Language: <em>{{ template.locale_name }}</em>
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="template.expires_at">
              Expires: <em>{{ template.expires_at | datetime('MMMM D, YYYY') }}</em>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>
<script>
import shareTemplateService from '../../../../../ml/services/shareTemplateService';

export default {
  props: {
    limit: {
      type: Number,
      required: false,
      default: Number.POSITIVE_INFINITY,
    }
  },
  data() {
    return {
      templates: [],
    }
  },
  computed: {
    filteredTemplates() {
      return this.templates.filter(template => {
        return template.is_active
          && template.can_be_selected
          && (template.is_app || template.is_web)
      }).slice(0, this.limit);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.templates = await shareTemplateService.getRecentlyUsedTemplatesForCurrentUser();
    },
    selectTemplate(template) {
      this.$emit('selected', template);
    }
  }
}
</script>
